/*
 *
 * LanguageProvider actions
 *
 */

import { CHANGE_LOCALE, CHANGE_LANGUAGE, CHANGE_LANGUAGE_REQUEST, LANGUAGE_SELECT_MODAL, LANGUAGE_UPDATE_FAILURE } from './constants';

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}

export function changeLanguage(language) {
  return {
    type: CHANGE_LANGUAGE,
    language
  };
}

export function changeLanguageRequest(language) {
  return {
    type: CHANGE_LANGUAGE_REQUEST,
    language
  };
}

export function handleLanguageSelectModal(open) {
  return {
    type: LANGUAGE_SELECT_MODAL,
    open,
  };
}

export function languageUpdateFailure(error) {
  return {
    type: LANGUAGE_UPDATE_FAILURE,
    error,
  };
}